
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDirection } from '@/providers/DirectionProvider';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from '@/components/ui/dialog';

interface LoginRequiredDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onGoToLogin: () => void;
}

const LoginRequiredDialog: React.FC<LoginRequiredDialogProps> = ({
  isOpen,
  onOpenChange,
  onGoToLogin
}) => {
  const { t } = useTranslation();
  const { direction } = useDirection();

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" dir={direction}>
        <DialogHeader>
          <DialogTitle>{t('dialogs.loginRequired.title')}</DialogTitle>
          <DialogDescription>
            {t('dialogs.loginRequired.description')}
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-4 py-4">
          <p className="text-sm text-muted-foreground">
            {t('dialogs.loginRequired.message')}
          </p>
        </div>
        <DialogFooter className="flex-col sm:flex-row gap-2">
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            className="w-full sm:w-auto"
          >
            {t('common.cancel')}
          </Button>
          <Button
            onClick={onGoToLogin}
            className="w-full sm:w-auto bg-[#00D09E] hover:bg-[#00C090]"
          >
            {t('dialogs.loginRequired.goToLoginButton')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default LoginRequiredDialog;
